import React from "react";

export default class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logs: [],
      refreshKey: 0, // used to force remounting child
    };
  }

  componentDidCatch(error, errorInfo) {
    const message = `REACT ERROR: ${error.toString()}\n${
      errorInfo.componentStack
    }`;
    this.handleError(message);
  }

  componentDidMount() {
    window.onerror = (msg, url, lineNo, columnNo, error) => {
      const message = `JS ERROR: ${msg} at ${url}:${lineNo}:${columnNo}`;
      this.handleError(message);
    };

    window.onunhandledrejection = (event) => {
      const message = `UNHANDLED PROMISE: ${event.reason}`;
      this.handleError(message);
    };
  }

  handleError = (message) => {
    const time = new Date().toLocaleTimeString();
    const fullMessage = `[${time}] ${message}`;

    this.setState((prev) => ({
      logs: [...prev.logs, fullMessage],
    }));

    // Give it a short delay to show the error, then reset the child
    setTimeout(() => {
      this.setState((prev) => ({ refreshKey: prev.refreshKey + 1 }));
    }, 1500);
  };

  render() {
    return (
      <>
        <div key={this.state.refreshKey}>{this.props.children}</div>
        {this.state.logs.length > 0 && (
          <div style={styles.debugBox}>
            {this.state.logs.map((log, index) => (
              <div key={index} style={styles.logText}>
                {log}
              </div>
            ))}
          </div>
        )}
      </>
    );
  }
}

const styles = {
  debugBox: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    maxHeight: "200px",
    overflowY: "auto",
    backgroundColor: "#111",
    color: "#0f0",
    fontFamily: "monospace",
    fontSize: "12px",
    padding: "10px",
    borderTop: "2px solid #0f0",
    zIndex: 9999,
    whiteSpace: "pre-wrap",
  },
  logText: {
    marginBottom: "4px",
  },
};
